const gameParamater = require('../define/gameParamater').default;

const isInsideArea = (posX, posY) => {
    return (0 <= posX && posX < gameParamater.VERTICAL_PANEL && 0 <= posY && posY < gameParamater.HORIZONTAL_PANEL)
}

export default {
    isInsideArea
}